import moize from 'moize'
import { createClient } from '@connectrpc/connect'

import type {
  PatchCustomerRequest,
  PatchCustomerResponse,
} from '@jotta/grpc-connect-openapi/customer'
import { CustomerService } from '@jotta/grpc-connect-openapi/customer'
import type { PartialMessage } from '@jotta/types/compat'

import { authTransport } from '../transport'

export const getCustomerClient = moize(() =>
  createClient(CustomerService, authTransport),
)

export function patchCustomer(
  args: PartialMessage<PatchCustomerRequest>,
): Promise<PatchCustomerResponse> {
  return getCustomerClient().patchCustomer(args)
}
